module.exports = __webpack_public_path__ + "img/CA.65250f1b.svg";